// Module
var code = `<div class="passwordContainer">
    <investingTextBox
        inputType="{{passwordHided ? 'password' : 'text'}}"
        visible="{{visible}}"
        name="{{name}}"
        haveError="{{haveError}}"
        text="{{text}}"
        enabled="{{enabled}}"
        focused="{{focused}}"
        tooltip="{{tooltip}}"
        placeholder="{{placeholder}}"
        styleClassed="{{elementStyle}}"
    />

    <investingButton
        name="{{passwordHided ? 'showPassEye' : 'hidePassEyeCrossed'}}"
        visible="{{showPasswordPreview}}"
        tooltip="{{passwordHided ? showPassEyeTooltip : hidePassEyeCrossedTooltip}}"
        investingButtonStyle="passwordPreviewEye"
        SVG="true"
        on-btnHover="showPassEye_btnHover"
        on-btnClick="showPassEye_btnClick"
    />
</div>
`;
// Exports
export default code;